import * as React from 'react';

function RateEstandar(props) {
  return (
    <svg width={40} height={56} fill="none" {...props}>
      <rect
        width={40}
        height={56}
        rx={4}
        fill="url(#prefix__paint0_linear_984_12547)"
      />
      <path
        opacity={0.5}
        d="M8 35h23M8 41h23M8 47h23"
        stroke="#B89EFF"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <path
        d="M24.4 11.52l-1.34 2.34c-.8-.54-1.66-.96-2.48-1.18v3.04c3.04.82 4.34 2.04 4.34 4.28v.04c0 2.24-1.74 3.68-4.24 3.94v1.98H18.6v-2.02c-1.74-.22-3.38-.88-4.72-1.9l1.56-2.28c1.1.82 2.06 1.38 3.26 1.62V18.2c-2.88-.8-4.3-1.84-4.3-4.24v-.04c0-2.2 1.68-3.66 4.2-3.92V8.84h2.08v1.22c1.44.18 2.6.68 3.72 1.46zM22 20.2v-.04c0-.66-.32-1.08-1.42-1.48v2.8c.94-.14 1.42-.58 1.42-1.28zm-4.68-6.46v.04c0 .64.28 1.04 1.38 1.44V12.5c-.98.14-1.38.6-1.38 1.24z"
        fill="#3E0C9D"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_984_12547"
          x1={20}
          y1={0}
          x2={20}
          y2={56}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F0FF" />
          <stop offset={1} stopColor="#E4DEFC" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const MemoRateEstandar = React.memo(RateEstandar);
export default MemoRateEstandar;
